<template>
  <scroll-right-frame class="sql-executor-wrapper">
    <el-card>
      <div slot="header" class="card-header">
        <span>自定义SQL执行器</span>
      </div>

      <!-- 数据库选择 -->
      <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="12">
          <label style="font-weight: bold; margin-bottom: 8px; display: block;">选择数据库:</label>
          <el-select v-model="selectedDatabase" placeholder="请选择数据库" style="width: 100%;">
            <el-option
              v-for="db in databases"
              :key="db.value"
              :label="db.label"
              :value="db.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <label style="font-weight: bold; margin-bottom: 8px; display: block;">执行密码:</label>
          <el-input
            v-model="password"
            type="text"
            placeholder="请输入执行密码"
            style="width: 100%;">
          </el-input>
        </el-col>
      </el-row>

      <!-- SQL安全提示 -->
      <el-alert
        title="安全说明"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;">
        <div slot="default">
          <p>• 仅支持单表的 INSERT、UPDATE、DELETE 操作</p>
          <p>• 必须包含 WHERE 条件，且 WHERE 条件必须包含 id 字段</p>
          <p>• 支持使用分号(;)分隔多条SQL语句</p>
          <p>• 所有操作将被记录到执行日志中</p>
        </div>
      </el-alert>

      <!-- SQL输入框 -->
      <div style="margin-bottom: 20px;">
        <label style="font-weight: bold; margin-bottom: 8px; display: block;">SQL语句:</label>
        <el-input
          v-model="sqlText"
          type="textarea"
          :rows="10"
          placeholder="请输入SQL语句，支持使用分号分隔多条语句。"
          style="width: 100%;">
        </el-input>
      </div>

      <!-- 执行按钮 -->
      <el-row style="margin-bottom: 20px;">
        <el-col>
          <el-button
            type="primary"
            icon="el-icon-play"
            :loading="executing"
            :disabled="!canExecute"
            @click="executeSql">
            执行SQL
          </el-button>
          <el-button
            type="default"
            icon="el-icon-refresh"
            @click="clearAll">
            清空
          </el-button>
        </el-col>
      </el-row>

      <!-- 执行结果 -->
      <div v-if="executionResults.length > 0">
        <label style="font-weight: bold; margin-bottom: 8px; display: block;">执行结果:</label>

        <!-- 执行统计 -->
        <div style="margin-bottom: 15px;">
          <el-card :body-style="{ padding: '10px' }">
            <div style="display: flex; align-items: center; gap: 20px;">
              <span style="font-weight: bold;">执行统计:</span>
              <el-tag type="info">总数: {{ executionResults.length }}</el-tag>
              <el-tag type="success">成功: {{ successCount }}</el-tag>
              <el-tag type="danger">失败: {{ failureCount }}</el-tag>
            </div>
          </el-card>
        </div>

        <div
          v-for="(result, index) in executionResults"
          :key="index"
          style="margin-bottom: 15px;">

          <el-card :body-style="{ padding: '10px' }">
            <div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
              <span style="font-weight: bold;">SQL {{ index + 1 }}</span>
              <el-tag :type="result.success ? 'success' : 'danger'">
                {{ result.success ? '成功' : '失败' }}
              </el-tag>
            </div>

            <!-- 执行的SQL -->
            <div style="margin-bottom: 10px;">
              <strong>执行SQL:</strong>
              <pre style="background: #f5f5f5; padding: 8px; margin: 5px 0; border-radius: 4px; overflow-x: auto;">{{ result.sql }}</pre>
            </div>

            <!-- 执行结果 -->
            <div v-if="result.success">
              <strong>执行结果:</strong>
              <div v-if="result.data && result.data.length > 0" style="margin-top: 10px;">
                <!-- 查询结果表格 -->
                <el-table
                  :data="result.data"
                  border
                  size="mini"
                  max-height="300"
                  style="width: 100%;">
                  <el-table-column
                    v-for="column in result.columns"
                    :key="column"
                    :prop="column"
                    :label="column"
                    min-width="100">
                  </el-table-column>
                </el-table>
              </div>
              <div v-else style="margin-top: 10px;">
                <el-tag type="info">影响行数: {{ result.affectedRows || 0 }}</el-tag>
              </div>
            </div>

            <!-- 错误信息 -->
            <div v-else style="margin-top: 10px;">
              <strong>错误信息:</strong>
              <div style="color: #f56c6c; background: #fef0f0; padding: 8px; margin: 5px 0; border-radius: 4px;">
                {{ result.error }}
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </el-card>
  </scroll-right-frame>
</template>

<script>
import ScrollRightFrame from '../../../components/scroll-right-frame'
import util from '@/libs/util'

export default {
  name: 'sql-executor',
  components: {ScrollRightFrame},
  data() {
    return {
      selectedDatabase: '',
      password: '',
      sqlText: '',
      executing: false,
      executionResults: [],
      databases: [
        { value: 'api', label: 'cbb_api' },
        { value: 'aigc', label: 'cbb_aigc' },
        { value: 'censor', label: 'cbb_censor' },
        { value: 'cert_editor', label: 'cbb_cert_editor' },
        { value: 'chatbot', label: 'cbb_chatbot' },
        { value: 'face', label: 'cbb_face' },
        { value: 'invoice', label: 'cbb_invoice' },
        { value: 'logger', label: 'cbb_logger' },
        { value: 'misc', label: 'cbb_misc' },
        { value: 'nginx_config', label: 'cbb_nginx_config' },
        { value: 'notification', label: 'cbb_notification' },
        { value: 'pay', label: 'cbb_pay' },
        { value: 'scheduler_cloud', label: 'cbb_scheduler_cloud' },
        { value: 'websocket', label: 'cbb_websocket' },
        { value: 'distribution_system', label: 'distribution_system' },
        { value: 'xxl_job', label: 'xxl_job' },
        { value: 'common_login', label: 'common_login' }
      ]
    }
  },
  computed: {
    canExecute() {
      return this.selectedDatabase && this.password && this.sqlText.trim() && !this.executing
    },
    successCount() {
      return this.executionResults.filter(result => result.success).length
    },
    failureCount() {
      return this.executionResults.filter(result => !result.success).length
    }
  },
  methods: {
    async executeSql() {
      if (!this.canExecute) {
        this.$message.warning('请填写完整信息后再执行')
        return
      }

      this.executing = true
      this.executionResults = []

      try {
        const response = await util.ajax.post('/api/sql-executor/execute', {
          database: this.selectedDatabase,
          password: this.password,
          sql: this.sqlText
        })

        if (response.data.meta && response.data.meta.errCode === 0) {
          this.executionResults = response.data.data
          this.$message.success('SQL执行完成')
        } else {
          this.$message.error(response.data.meta ? response.data.meta.errMsg : 'SQL执行失败')
        }
      } catch (error) {
        console.error('SQL执行出错:', error)
        const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || '执行过程中发生错误'
        this.$message.error(errorMessage)
      } finally {
        this.executing = false
      }
    },

    clearAll() {
      this.selectedDatabase = ''
      this.password = ''
      this.sqlText = ''
      this.executionResults = []
      this.$message.info('已清空所有内容')
    }
  }
}
</script>

<style lang="scss" scoped>
.sql-executor-wrapper {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: #f5f5f5;

  .card-header {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
  }

  .el-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  pre {
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    line-height: 1.4;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .el-table {
    font-size: 12px;
  }

  .el-alert__content {
    line-height: 1.6;
  }
}
</style>



// WEBPACK FOOTER //
// src/custom/components/sql-executor/sql-executor.vue